import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { CardSetTransformationService, DialogService, CoreService, SpinnerService, DataService, SaveDataRequest, VerticalNavigationSettings, SaveFormEvent, FormNavigationService, ElementType, Option } from 'dspx-core';
import { Subscription, bufferTime, filter } from 'rxjs';
import { API_ENDPOINT_KEYS, API_ENDPOINTS } from 'src/app/constants/api-endpoints.constants';
import { APP_DATA_KEYS, FORM_IDENTIFIERS, NAV_TAB_NUMBERS, PAGE_NUMBERS, POP_UP_CODES, QUESTION_CODES, SECTION_CODES } from 'src/app/constants/app-data.constants';
import { TEMPLATES, VERSIONS } from 'src/app/constants/templates.constants';
import { AppDataService } from 'src/app/services/app-data.service';
import { ErrorService } from 'src/app/services/error.service';
import { ResponseParserService } from '../../services/response-parser.service';
import { ConcessionsApplicationBaseComponent } from '../concessions-application-base-component/concessions-application-base-component';
import { Guid } from 'guid-typescript';
import * as _ from 'lodash';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-concessions-applicationeda-and-pow-gold-card-municipal-rates',
  templateUrl: './concessions-application-eda-and-pow-gold-card-municipal-rates.component.html',
  styleUrls: ['./concessions-application-eda-and-pow-gold-card-municipal-rates.component.scss']
})
export class ConcessionsApplicationEdaAndPowGoldCardMunicipalRatesComponent extends ConcessionsApplicationBaseComponent implements OnInit, OnDestroy {

  fieldTypeReplacements =
    CardSetTransformationService.cardSetFieldTypeReplacements;
  formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;
  verticalNavigationSettings: VerticalNavigationSettings = { enabled: true, sticky: true, pageLevel: true, type: 'horizontal-stepper' };
  formNavSubscription: Subscription;

  private _previousTab: number = 1;
  private _previousPage: number = 1;
  private _currentTab: number = 1;
  private _currentPage: number = 1;

  templateId: number = TEMPLATES.concessionsApplicationedaAndPowGoldCardMunicipalRates;
  versionNo: number = VERSIONS.latest;
  model: any;
  editing: boolean = false;
  primaryAddressIsManual: boolean = false;
  activeApplications: any;

  constructor(protected router: Router,
    protected route: ActivatedRoute,
    protected dialogService: DialogService,
    protected appDataService: AppDataService,
    protected responseParserService: ResponseParserService,
    protected spinnerService: SpinnerService,
    protected errorService: ErrorService,
    protected dataService: DataService,
    private coreService: CoreService,
    private formNavigationService: FormNavigationService,
    private viewportScroller: ViewportScroller
  ) {
    super(router, route, dataService, appDataService, responseParserService, dialogService, spinnerService, errorService);
  }

  ngOnInit(): void {
    this.formServiceEndpoint = API_ENDPOINT_KEYS.getConcessionsApplicationEdaAndPowGoldCardMunicipalRatesConfigAndResponse;
    this.saveEndpoint = API_ENDPOINTS.concessionsApplicationEdaAndPowGoldCardMunicipalRates.save;

    this.registerSubscription(
      this.route.paramMap.subscribe((paramMap: ParamMap) => {
        const id = paramMap.get('id');
        const personId = paramMap.get('personId');

        if (id) {
          this.id = id;
          this.editing = true;
        } else if (personId) {
          this.id = `${Guid.EMPTY}/${personId}`
          this.personId = personId;
        }
        else {
          this.resetDirtyFlagAfterLoading();
        }
      })
    );

    this.coreService.conditionFunctions = {
      isEditing: () => this.editing,
      isPrimaryAddressManual: () => this.isPrimaryAddressManual(),
      isPrimaryAddressAuto: () => this.isPrimaryAddressAuto(),
      exit: () => this.exit(),
      true: () => true,
      readOnly: () => true,
      isConsentNotAgree: () => this.isConsentNotAgree(),
      isConsentAgree: () => this.isConsentAgree(),
      showEdapowCardNumber: () => this.isConsentAgree(),
      isConsentNotsignedandNoConfirmation: () => this.isConsentNotsignedandNoConfirmation(),
      showSignedApplicationUpload: () => this.showSignedApplicationUpload(),
      isCustomerPortalApplication: () => this.isCustomerPortalApplication(),
      isStaffPortalApplication: () => this.isStaffPortalApplication(),
      addNewPostalAddress: () => this.addNewPostalAddress(),
      isReadOnly: () => this.isReadOnly(),
      isFirstNameReadonly: () => this.isFirstNameReadonly(),
      isLastNameReadonly: () => this.isLastNameReadonly(),
      isEmailReadonly: () => this.isEmailReadonly(),
      isMobilePhoneReadonly: () => this.isMobilePhoneReadonly(),
      isOtherPhoneReadonly: () => this.isOtherPhoneReadonly(),
      isDateOfBirthReadonly: () => this.isDateOfBirthReadonly(),
      isPrimaryAddressReadonly: () => this.isPrimaryAddressReadonly(),
      isPostalAddressSameAsPrimaryAddressReadonly: () => this.isPostalAddressSameAsPrimaryAddressReadonly(),
      isPostalAddressReadonly: () => this.isPostalAddressReadonly()
    }

    this.coreService.applicationFunctions = {
      exit: () => this.exit(),
    }

    this.registerSaveOnNavigation();
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
    this.formNavSubscription.unsubscribe();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    this.coreService.repeatingSectionFunctions = {};
  }

  formLoaded($event) {
    if (this.baseForm && this.baseForm.model) {
      this.appDataService.setAppData(APP_DATA_KEYS.previousModel, JSON.parse(JSON.stringify(this.baseForm.model)));
    }
    super.formLoad($event);
    this.activeApplications = $event.activateApplications;
    this.formHeaderModel = $event.headerResponse;
    this.isPersonBothCarerAndConcessionsApplicant = $event.isPersonBothCarerAndConcessionsApplicant;
    this.isPersonWithActiveCareAllowancePlacements = $event.isPersonWithActiveCareAllowancePlacements;

    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.invoiceDocumentElectricity] = FORM_IDENTIFIERS.concessionsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.entitlementLetter] = FORM_IDENTIFIERS.concessionsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsWaterForm.signedApplication] = FORM_IDENTIFIERS.concessionsFormIdentifier;
    this.coreService.fileUploadFormIdentifiers[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.ratesuploadDocument] = FORM_IDENTIFIERS.concessionsFormIdentifier;
  }

  home(event: any) {
    this.navigateBackToHome();
  }

  exit(){
    this.navigateBackToHome();
  }

  save(event: SaveFormEvent) {
    const saveDataRequest: SaveDataRequest = {
      template: this.templateId,
      versionNumber: this.versionNo,
      id: this.id,
      response: event.model,
      expectedLastUpdateTime: event.lastUpdatedTime,
      isSubmit: event.isSubmit
    }
    if (event.isSubmit) {
      if (event.isFormValid === false) {
        this.baseForm.markAllFieldsAsTouched();
        this.baseForm.showValidationSummary(true);
      }
      else {
        // submit application
        this.saveData(saveDataRequest);
      }
    }
    else {
      this.saveData(saveDataRequest);
    }
  }

  cancel(event: any) {
    if (this.formNavigationService.currentTabIndex == 0 && this.formNavigationService.currentPageIndex == 0) {
      this.navigateToConcessionsInfo();
    } else {
      this.formNavigationService.moveBack();
    }
  }

  dialogSubmit(event: any): void {
    switch (this.activeDialog) {
      case POP_UP_CODES.concessionsApplicationCommon.submitSuccessful: {
        this.navigateBackToHome(true);
        break;
      }
    }
  }

  modelChange(event: any): void {
    if (this.baseForm?.model) {
      var addressSection = this.baseForm?.model?.form?.tabs?.tab2?.page1?.address;
      if (addressSection) {
        var value = addressSection[QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.primaryAddressManualAddress];
        this.primaryAddressIsManual = (value === true);
      }
      this.updateHeaderSubtitle(this.baseForm.optionSets.financialyear as Option[]);
    }
  }

  isPrimaryAddressManual(): boolean {
    return this.primaryAddressIsManual;
  }

  isPrimaryAddressAuto(): boolean {
    return !this.primaryAddressIsManual;
  }
 
  private registerSaveOnNavigation() {
    this.formNavSubscription =
      this.formNavigationService.onNavigation()
        .pipe(
          bufferTime(200),
          filter(x => x.length > 0)
        ).subscribe(async (data) => {
          this.viewportScroller.scrollToPosition([0, 0]); //Always navigate to the top of the page

          let tabNumber = data.find(x => x.elementType === ElementType.TAB)?.elementNumber
          let pageNumber = data.find(x => x.elementType === ElementType.PAGE)?.elementNumber

          if (this.coreService.isFormEditable === true) {
            // If the user is navigating forwards
            if (tabNumber > this._currentTab || pageNumber > this._currentPage) {
              //introduction confirmation check
              if (this._currentPage == PAGE_NUMBERS.concessionsApplicationEdapowGoldCardMunicipalRatesForm.intro
                && this._currentTab == NAV_TAB_NUMBERS.concessionsApplicationEdapowGoldCardMunicipalRatesForm.intro) {

                if (!this.selectedApplyForYear) {
                  this.updateHeaderSubtitle(this.baseForm.optionSets.financialyear as Option[]);
                }

                if (this.activeApplications) {
                  // check if there is active application for selected year
                  const selectedApplicationYearApplicationsCount = this.activeApplications
                    .filter(item => item.applicationYear === this.selectedApplyForYear)
                    .map(item => item.count)
                    .find(count => count !== undefined);

                  if (selectedApplicationYearApplicationsCount != null && selectedApplicationYearApplicationsCount > 0) {
                    this.activeDialog = POP_UP_CODES.concessionsApplicationCommon.applicationInProgress;
                    this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.applicationInProgress, null, { applicationYear: this.applicationPeriod }, false);

                    this.formNavigationService.setActiveNumber(ElementType.TAB, this._currentTab);
                    this.formNavigationService.setActiveNumber(ElementType.PAGE, this._currentPage);
                    return;
                  }
                }
              }

              //check address is in victoria
              if (this._currentPage == PAGE_NUMBERS.concessionsApplicationEdapowGoldCardMunicipalRatesForm.applicant
                && this._currentTab == NAV_TAB_NUMBERS.concessionsApplicationEdapowGoldCardMunicipalRatesForm.applicant) {
                const addressInVic = this.isAddressInVictoria(this.baseForm.model.form.tabs.tab2.page1.address, QUESTION_CODES.concessionsApplicationNonMainsEnergyForm.primaryAddress)
                if (!addressInVic) {
                  this.dialogService.showDialog(POP_UP_CODES.concessionsApplicationCommon.invalidResidentialAddress);
                  // prevent navigation away
                  this.formNavigationService.setActiveNumber(ElementType.TAB, this._currentTab);
                  this.formNavigationService.setActiveNumber(ElementType.PAGE, this._currentPage);
                  return;
                }

                // setting the Concession Card number
                let profileVeteransAffairsFileNumber = this.baseForm.model.form.tabs.tab2.page1?.profileCardDetails?.profileVeteransAffairsFileNumber;

                if (profileVeteransAffairsFileNumber) {
                  _.set(this.baseForm.model,
                    ['form', 'tabs',
                      'tab' + NAV_TAB_NUMBERS.concessionsApplicationEdapowGoldCardMunicipalRatesForm.concessionsCard,
                      'page' + PAGE_NUMBERS.concessionsApplicationEdapowGoldCardMunicipalRatesForm.concessionsCard,
                      SECTION_CODES.concessionsApplicationEdapowGoldCardMunicipalRatesForm.cardDetails,
                      QUESTION_CODES.concessionsApplicationEdaAndPowGoldCardMunicipalRatesForm.edapowCardNumber],
                    profileVeteransAffairsFileNumber);
                }
              }

              // This condition added to avoid calling backend API more than once
              // on component initialization.
              if (this._previousPage !== this._currentPage || this._previousTab !== this._currentTab) {
                this._previousTab = this._currentTab;
                this._previousPage = this._currentPage;
                if (this.isDraftApplication) {
                  this.saveOnNavigation(this.templateId, this.versionNo);
                }
              }
            }
          }

          this._currentTab = tabNumber ?? this._currentTab;
          this._currentPage = pageNumber ?? this._currentTab;
        });
  }
}
